import React, { FC, useCallback, useEffect } from 'react'
import { useSearchForm } from '../hooks'

declare const window: any;

const SearchForm: FC = () => {
  const { lastNameRef, bookingDateRef, releaseDateRef, isSearching, search, clear } = useSearchForm()
  const handleEnter = useCallback((event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      search()
    }
  }, [search])

  useEffect(() => {
    if (bookingDateRef.current && releaseDateRef.current) {
      const $ = window.jQuery

      $('.datepicker').datepicker({
        //format: 'yyyy-mm-dd',
        autoclose: true
      })
    }
  }, [bookingDateRef, releaseDateRef])

  return (
    <div className="span6 bottom-buffer">
      <label htmlFor="txtLastName">Last Name:</label>
      <input type="text" id="txtLastName" className="input-block-level" onKeyUp={handleEnter} ref={lastNameRef} disabled={isSearching} />
      <div className="row-fluid">
        <div className="span6">
          <label htmlFor="txtBookingDate">Booking Date:</label>
          <input type="text" id="txtBookingDate" className="input-block-level datepicker" onKeyUp={handleEnter} ref={bookingDateRef} disabled={isSearching} />
        </div>
        <div className="span6">
          <label htmlFor="txtReleaseDate">Release Date:</label>
          <input type="text" id="txtReleaseDate" className="input-block-level datepicker" onKeyUp={handleEnter} ref={releaseDateRef} disabled={isSearching} />
        </div>
      </div>
      <hr />
      {isSearching ?
        <div>
          <button disabled={true}><i className="icon-search"></i>&nbsp;&nbsp;Searching...</button>
          <button disabled={true}>Reset Form</button>
        </div>
        :
        <div>
          <button onClick={search}><i className="icon-search"></i>&nbsp;&nbsp;Search</button>
          <button onClick={clear}>Reset Form</button>
        </div>
      }
    </div>
  )
}

export default SearchForm